import classNames, {Argument} from 'classnames';
import * as React from 'react';

import styles from './ComponentBoxHeaderFooter.less';

interface OwnProps {
  className?: Argument;
  helpText?: string;
  hidden?: boolean;
  showBorderBottom?: boolean;
  showHelp?: boolean;
  showTitle?: boolean;
  titleText?: string;
}
type Props = OwnProps;

export const ComponentBoxHeaderFooter: React.FC<Props> = (props) => {
  const {
    children,
    className = '',
    helpText,
    hidden = false,
    showBorderBottom = true,
    showHelp = true,
    showTitle = true,
    titleText,
  } = props;
  return (
    <header
      className={classNames(className, {
        [styles.dlFixedColumn]: true,
      })}
      hidden={hidden}
    >
      <div
        className={classNames({
          [styles.dlHeaderContentWrapper]: true,
          [styles.dlHeaderPadding]: true,
          [styles.dlHeaderBorder]: showBorderBottom,
        })}
      >
        {showTitle && titleText ? (
          <span className={styles.dlHeaderTitleText}>{titleText}</span>
        ) : null}
        <span className={styles.dlHeaderChildren}>{children}</span>
        {showHelp && helpText ? (
          <div
            className={classNames({
              [styles.dlHeaderButton]: true,
              'float-end': true,
            })}
          >
            <i className={'fas fa-question fa-fw fa-1x'} title={helpText} />
          </div>
        ) : null}
      </div>
    </header>
  );
};

ComponentBoxHeaderFooter.displayName = 'ComponentBoxHeaderFooter';
